<template>
  <v-list-group :value="item.title">
    <template v-slot:activator="{ props }">
      <v-list-item
        v-bind="props"
        :prepend-icon="item.sicon || item.icon"
        :title="item.title"
      />
    </template>

    <template v-for="(child, i) in children" :key="`child-${i}`">
      <BaseItemSubGroup v-if="child.children" :item="child" />
      <BaseItem v-else :item="child" :show-icon="false" />
    </template>
  </v-list-group>
</template>

<script>
  export default {
    name: 'BaseItemGroup',

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          avatar: undefined,
          group: undefined,
          title: undefined,
          children: [],
        }),
      },
      subGroup: {
        type: Boolean,
        default: false,
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      children () {
        return this.item.children.map(child => ({
          ...child,
          to: !child.to ? undefined : `${this.item.group}/${child.to}`,
        }))
      },
    },
  }
</script>
